/* A372 — dimension filters as a range, not a checkbox per millimetre.
 *
 * Shopify has no range filter for a metafield: `...product_width_mm.gte=600`
 * is silently ignored and returns the unfiltered collection. The only shape it
 * honours is the repeated exact value. So this reads the values the theme has
 * already rendered as checkboxes, replaces them with one range control, and on
 * apply submits every value inside the range as its own parameter.
 *
 * Everything downstream stays native: Shopify does the filtering, the paging
 * and the counts, and the checkbox list is still in the DOM for anyone without
 * JavaScript.
 */
(function () {
  'use strict';
  if (window.__rbDimRange) { return; }
  window.__rbDimRange = true;

  /* The size metafields, in both shapes. Matching on the PARAM name, not the
     label, because the label is merchant-typed in the Search & Discovery app
     and can be renamed; the param is the metafield key and cannot.
       custom.product_width_mm    exact sizes  -> "600"
       custom.product_width_band  50mm bands   -> "0600-0649"
     Bands are what A372 moved to, because one drag then costs 7 parameters
     instead of 115 and the page stays its normal weight. The exact shape is
     still handled so the control keeps working on any store, and during the
     window where both filters are switched on. */
  var PARAM_RE = /_(mm|band)$/;
  /* Under this many sizes a plain list is friendlier than a slider, and a
     slider over two values is faintly ridiculous. */
  var MIN_VALUES = 4;
  var BARS = 30;

  /* ☠️ EVERY size in the catalogue, baked in at deploy time — NOT the sizes the
     sidebar rendered. Shopify displays at most 100 values per filter and drops
     the rest, keeping the commonest: CE has 624 distinct widths but any one
     collection page shows 100. Ticking only what was rendered would inherit
     that blindness — in the 500-800mm band alone it costs 223 of 990 products.
     The 100 is a DISPLAY cap; applying more than 100 works fine. */
  var STORE = {"custom.product_width_mm":[176,265,300,308,325,334,350,353,360,395,400,425,435,467,475,485,487,496,519,530,535,538,540,555,558,560,564,580,595,598,600,605,606,608,610,615,630,632,645,650,654,660,670,685,686,698,700,702,719,729,730,740,750,755,760,762,768,770,780,786,796,808,811,813,816,865,886,900,908,910,913,914,915,924,931,1000,1004,1010,1012,1018,1022,1042,1070,1096,1100,1117,1130,1131,1133,1194,1197,1198,1200,1205,1218,1219,1220,1223,1225,1227,1229,1230,1235,1270,1298,1300,1314,1318,1321,1330,1334,1350,1360,1365,1370,1375,1396,1400,1405,1411,1415,1460,1463,1465,1467,1480,1500,1505,1510,1520,1524,1530,1531,1534,1548,1552,1580,1600,1605,1629,1650,1696,1700,1702,1709,1727,1730,1750,1795,1800,1805,1820,1829,1832,1839,1840,1846,1865,1900,1955,1959,1976,1985,1996,2000,2005,2010,2013,2050,2055,2060,2091,2095,2100,2120,2134,2191,2200,2230,2268,2296,2300,2362,2369,2373,2400,2426,2500,2580,2584,2600,2700,2794,2800,2900,3000,3029,3100,3200,3300,3400,3500,3600,3700,3800,3900,4000],"custom.product_depth_mm":[108,162,176,230,260,265,300,310,320,325,335,340,355,360,395,404,457,475,488,504,520,530,532,536,539,540,543,560,570,575,580,581,585,588,591,595,598,600,610,613,615,620,623,627,629,631,635,640,643,650,660,663,670,680,690,700,705,711,713,714,715,720,725,730,738,740,742,750,751,753,755,757,759,762,765,766,775,778,780,790,800,801,805,815,816,818,823,830,832,840,841,843,850,854,858,863,865,867,870,873,884,900,915,945,959,985,1000,1026,1064,1080,1086,1150,1700],"custom.product_height_mm":[20,40,50,60,65,100,150,200,227,245,255,289,300,332,380,381,385,386,410,417,435,460,476,485,500,531,554,562,575,580,581,599,609,610,648,650,660,670,676,678,690,700,712,721,750,755,788,790,800,802,816,824,825,835,838,839,840,850,870,881,882,888,892,893,897,900,903,911,922,943,945,949,950,956,960,961,966,967,1000,1004,1035,1043,1045,1052,1055,1080,1087,1093,1105,1115,1117,1124,1128,1133,1157,1168,1180,1181,1185,1197,1200,1220,1224,1268,1290,1296,1310,1325,1350,1360,1393,1400,1420,1435,1586,1617,1725,1840,1844,1855,1856,1877,1910,1915,1925,1940,1950,1955,1994,1995,1996,1998,2000,2010,2023,2054,2058,2065,2074,2075,2079,2080,2081,2090,2095,2100,2185]};

  /* ☠️ A hard 16 KiB wall on the request URI, measured: 408 values / 16,376
     chars returned 200, 409 / 16,416 returned HTTP 414. Stay well under it and
     leave room for the other filters already in the URL. */
  var URL_BUDGET = 15000;

  /* ☠️☠️ THE WALL THAT BINDS FIRST IS PAGE WEIGHT, NOT URL LENGTH.
     Shopify echoes the whole query string into EVERY facet link twice (href and
     data-url) and into every pagination link, so each extra size inflates the
     HTML of the page it loads. Measured on the live store, 13-08-2026:

        upright-freezers   plain 1.18 MB -> 2.88 MB for 600-900mm  (14.4 KB/size)
        commercial-fridges plain 1.51 MB -> 5.28 MB for 600-900mm  (32.0 KB/size)
        commercial-fridges                  7.82 MB for 600-1200mm (34.2 KB/size)

     A five-megabyte collection page on a phone is not a filter, it is a bill.
     So the number of sizes is capped by an estimate of what they will cost, and
     a band too expensive to spell out exactly falls back to the sizes this page
     rendered — which is precisely what a shopper could reach by ticking boxes
     today, so the cap is never worse than the thing it replaces.
     ★ The estimate is measured per page, because the cost is driven by how many
     facet links the collection has: fridges has 363 of them, upright freezers
     140, and that is the whole difference between 32 KB and 14 KB a size. */
  var WEIGHT_BUDGET = 1500000;

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  /* Roughly what one more size costs this page, in bytes of HTML. Every filter
     link carries the query string twice, every pagination link once. */
  function costPerValue(param) {
    var echoes = document.querySelectorAll('a[data-filter-input]').length * 2
               + document.querySelectorAll('.pagination a, [data-pagination] a').length
               + 8;
    return echoes * (param.length + 6);
  }

  /* Say what was actually asked for. "428 – 1,433mm" reads as a filter on both
     ends when only one end was moved. */
  function phrase(from, to, lo, hi) {
    if (from <= lo && to >= hi) { return 'any size'; }
    if (from <= lo) { return 'up to ' + fmt(to) + 'mm'; }
    if (to >= hi) { return fmt(from) + 'mm and over'; }
    return fmt(from) + '\u2013' + fmt(to) + 'mm';
  }

  function readGroup(group) {
    var links = group.querySelectorAll('a[data-filter-input][data-value]');
    if (!links.length) { return null; }
    var param = links[0].getAttribute('data-name') || group.getAttribute('data-rb-param');
    if (!param || !PARAM_RE.test(param)) { return null; }

    var values = [], active = [], i, raw, m, band;
    for (i = 0; i < links.length; i++) {
      raw = links[i].getAttribute('data-value');
      band = /^(\d+)-(\d+)$/.exec(raw);
      /* ☠️ A size or a band, and nothing else. One value that is neither means
         this is not the filter we think it is, and a slider over it would be
         nonsense. */
      if (!band && !/^\d+$/.test(raw)) { return null; }
      m = (links[i].textContent || '').match(/\((\d[\d,]*)\)/);
      values.push({
        /* v is where the value STARTS and hi is where it ENDS. For an exact
           size they are the same number; for a band they are its two edges,
           and both matter when deciding what a drag covers. */
        v: parseInt(band ? band[1] : raw, 10),
        hi: parseInt(band ? band[2] : raw, 10),
        raw: raw,
        c: m ? parseInt(m[1].replace(/,/g, ''), 10) : 0
      });
      if (links[i].hasAttribute('data-filter-active')) {
        active.push(parseInt(band ? band[1] : raw, 10));
      }
    }
    values.sort(function (a, b) { return a.v - b.v; });
    /* One anchor per distinct value is what Shopify renders, but a duplicate
       would be submitted twice and counted twice — inflating both the URL and
       the page-weight estimate for no gain. Cheap to rule out. */
    var uniq = [], u;
    for (u = 0; u < values.length; u++) {
      if (!uniq.length || uniq[uniq.length - 1].raw !== values[u].raw) { uniq.push(values[u]); }
    }
    values = uniq;
    if (values.length < MIN_VALUES) { return null; }
    return { param: param, values: values, active: active,
             banded: /_band$/.test(param) };
  }

  function build(group, data) {
    var values = data.values;
    /* The TRACK is scoped to this collection — a freezer page should not offer
       a 3,418mm handle because a bench somewhere is that wide. (REO gets this
       right too; what REO gets wrong is re-scoping the track to your SELECTION,
       so you can never widen it again. This never moves.) */
    var lo = values[0].v, hi = values[0].hi, k;
    for (k = 0; k < values.length; k++) { if (values[k].hi > hi) { hi = values[k].hi; } }
    var span = Math.max(1, hi - lo);
    /* Exactly 100 rendered means Shopify almost certainly cut the list. Bands
       never come close — 60 widths, 38 depths, 50 heights across all of CE. */
    var truncated = values.length >= 100;
    var key = data.param.replace(/^filter\.[pv]\.m\./, '');
    /* ☠️ The baked list is EXACT SIZES. Unioning it into a BAND filter would
       submit "600" to a filter whose values are all "0600-0649", which matches
       nothing — and an unmatched filter value returns an empty grid. Bands are
       complete on their own, so they never need it. */
    var full = data.banded ? [] : (STORE[key] || []);
    /* Re-opening a filtered page: the handles sit on what is actually applied.
       A bookmarked URL with gaps in it (someone ticked 600 and 900 but not 700)
       shows as 600–900; applying again makes it a true range. */
    var from = data.active.length ? Math.min.apply(null, data.active) : lo;
    var to = data.active.length ? Math.max.apply(null, data.active) : hi;

    var el = document.createElement('div');
    el.className = 'rbdr';
    el.innerHTML =
      '<div class="rbdr-fields">' +
        '<span class="rbdr-field"><input type="number" class="rbdr-from" inputmode="numeric">' +
          '<span class="rbdr-unit">mm</span></span>' +
        '<span class="rbdr-dash">\u2013</span>' +
        '<span class="rbdr-field"><input type="number" class="rbdr-to" inputmode="numeric">' +
          '<span class="rbdr-unit">mm</span></span>' +
      '</div>' +
      '<div class="rbdr-plot"></div>' +
      '<div class="rbdr-slider"><div class="rbdr-track"></div><div class="rbdr-fill"></div>' +
        '<input type="range" class="rbdr-h1"><input type="range" class="rbdr-h2"></div>' +
      '<div class="rbdr-ends"><span>' + fmt(lo) + 'mm</span><span>' + fmt(hi) + 'mm</span></div>' +
      '<div class="rbdr-foot"><span class="rbdr-count"></span>' +
        '<span class="rbdr-actions"></span></div>';

    var fromI = el.querySelector('.rbdr-from'), toI = el.querySelector('.rbdr-to');
    var h1 = el.querySelector('.rbdr-h1'), h2 = el.querySelector('.rbdr-h2');
    var fill = el.querySelector('.rbdr-fill'), plot = el.querySelector('.rbdr-plot');
    var countEl = el.querySelector('.rbdr-count'), actions = el.querySelector('.rbdr-actions');

    var label = (group.querySelector('.collection-filters__filter-title') || {}).textContent || '';
    fromI.setAttribute('aria-label', label.trim() + ' from, in millimetres');
    toI.setAttribute('aria-label', label.trim() + ' to, in millimetres');
    h1.setAttribute('aria-label', label.trim() + ' minimum');
    h2.setAttribute('aria-label', label.trim() + ' maximum');
    [h1, h2].forEach(function (h) { h.min = lo; h.max = hi; h.step = 1; });

    /* Where the stock actually sits, so a buyer can see at a glance which part
       of the track is worth dragging into.
       ☠️ Do NOT read this as "equipment comes in round sizes" — measured over
       all 3,581 CE products with dimensions, 600/900/1200/1500/1800 account for
       only 18.5% of widths and just 27% of widths are even a multiple of 100.
       That is precisely why a range beats a checkbox list here: there is no
       short list of sizes to offer. */
    var bars = [], buckets = [], i;
    for (i = 0; i < BARS; i++) { buckets.push(0); }
    values.forEach(function (p) {
      buckets[Math.min(BARS - 1, Math.floor((p.v - lo) / span * BARS))] += p.c;
    });
    var peak = Math.max.apply(null, buckets) || 1;
    for (i = 0; i < BARS; i++) {
      var b = document.createElement('i');
      b.style.height = Math.max(2, Math.round(buckets[i] / peak * 26)) + 'px';
      plot.appendChild(b);
      bars.push(b);
    }

    var applyBtn = document.createElement('button');
    applyBtn.type = 'button';
    applyBtn.className = 'rbdr-apply';
    applyBtn.textContent = 'Apply';
    var clearBtn = document.createElement('button');
    clearBtn.type = 'button';
    clearBtn.className = 'rbdr-clear';
    clearBtn.textContent = 'Any size';

    function inRange() {
      var n = 0;
      values.forEach(function (p) { if (p.v >= from && p.hi <= to) { n += p.c; } });
      return n;
    }
    function isWhole() { return from <= lo && to >= hi; }
    function isApplied() { return data.active.length > 0; }

    function paint() {
      /* ★ Empty means "no limit", the way the theme's own price boxes read.
         REO fills theirs with the catalogue floor — "0.00" — which looks like a
         filter nobody set and quietly sweeps in every product with no size at
         all. A box we have not been given a number for stays blank. */
      fromI.value = (from <= lo) ? '' : from;
      toI.value = (to >= hi) ? '' : to;
      fromI.placeholder = lo;
      toI.placeholder = hi;
      h1.value = from; h2.value = to;
      var a = (from - lo) / span * 100, z = (to - lo) / span * 100;
      fill.style.left = a + '%';
      fill.style.width = Math.max(0, z - a) + '%';
      for (var j = 0; j < BARS; j++) {
        var mid = lo + (j + 0.5) / BARS * span;
        bars[j].className = (mid >= from && mid <= to) ? 'on' : '';
      }
      /* \u2620\ufe0f Only claim a number when we can stand behind it. The counts come from
         the rendered facet; if that list was cut at 100 the sum understates the
         result, and a count that disagrees with the grid is worse than none. */
      var n = inRange();
      if (truncated) {
        countEl.textContent = phrase(from, to, lo, hi);
      } else {
        countEl.textContent = n === 0
          ? 'No products this size'
          : fmt(n) + ' product' + (n === 1 ? '' : 's') + ' \u00b7 ' + phrase(from, to, lo, hi);
      }
      countEl.className = 'rbdr-count' + (!truncated && n === 0 ? ' rbdr-none' : '');

      actions.innerHTML = '';
      /* Nothing to apply when the handles are where the page already is. */
      var dirty = isWhole() ? isApplied()
                            : (from !== (data.active.length ? Math.min.apply(null, data.active) : lo) ||
                               to !== (data.active.length ? Math.max.apply(null, data.active) : hi));
      if (isWhole() && isApplied()) { actions.appendChild(clearBtn); }
      else if (dirty) {
        applyBtn.disabled = (!truncated && n === 0);
        actions.appendChild(applyBtn);
      } else if (isApplied()) { actions.appendChild(clearBtn); }
    }

    /* ☠️ An emptied box means "no limit on this end", so it falls back to that
       end of the track — not to zero and not to the other handle. Clearing the
       To box with a lo-default would have collapsed the range onto From and
       shown one size. */
    function clamp(v, dflt) {
      v = parseInt(v, 10);
      if (isNaN(v)) { return dflt; }
      return Math.max(lo, Math.min(hi, v));
    }
    function setFrom(v) { from = Math.min(clamp(v, lo), to); paint(); }
    function setTo(v) { to = Math.max(clamp(v, hi), from); paint(); }

    h1.addEventListener('input', function () { setFrom(h1.value); });
    h2.addEventListener('input', function () { setTo(h2.value); });
    /* Apply on release, not on every frame: each apply is a page load. */
    h1.addEventListener('change', go);
    h2.addEventListener('change', go);
    fromI.addEventListener('change', function () { setFrom(fromI.value); });
    toI.addEventListener('change', function () { setTo(toI.value); });
    [fromI, toI].forEach(function (inp) {
      inp.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); inp.blur(); go(); }
      });
    });
    applyBtn.addEventListener('click', go);
    clearBtn.addEventListener('click', function () { from = lo; to = hi; go(); });

    /* ☠️ UNION, never "the baked list if there is one". CF has dimensions on 6
       of 1,822 products, so a store list can be far SHORTER than what a
       collection rendered; preferring it would drop nearly everything. The
       union is never worse than either source, and it also survives the baked
       list going stale between deploys. */
    function sourceValues() {
      if (!full.length) { return values; }
      var seen = {}, out = [], i, k;
      for (i = 0; i < values.length; i++) { seen[values[i].v] = 1; }
      for (i = 0; i < full.length; i++) { seen[full[i]] = 1; }
      for (k in seen) {
        if (Object.prototype.hasOwnProperty.call(seen, k)) {
          out.push({ v: parseInt(k, 10), hi: parseInt(k, 10), raw: k });
        }
      }
      out.sort(function (a, b) { return a.v - b.v; });
      return out;
    }

    /* Which sizes to submit. A handle parked on the end of its track means
       "and everything past this", not "exactly the biggest size this page
       happened to render" — which is how a 2,866mm fridge stays reachable even
       though the sidebar's list stopped at 2,230. */
    function pick(list) {
      var lowOpen = from <= lo, highOpen = to >= hi, out = [], i;
      for (i = 0; i < list.length; i++) {
        /* ☠️ A band goes in only if it lies WHOLLY inside the selection. Asked
           for "up to 900mm", a shopper must not be shown a 940mm unit because
           it shares the 900-949 band — the whole point of the filter is that
           the thing fits. The applied range is then reported back as what it
           really is (600-899mm), so the number they see is the number they
           got. */
        if ((lowOpen || list[i].v >= from) && (highOpen || list[i].hi <= to)) {
          out.push(list[i]);
        }
      }
      return out;
    }

    function query(picked) {
      var p = new URLSearchParams(window.location.search);
      p.delete(data.param);
      p.delete('page');
      for (var i = 0; i < picked.length; i++) {
        p.append(data.param, picked[i].raw);
      }
      return p.toString();
    }

    function go() {
      if (!truncated && inRange() === 0 && !isWhole()) { paint(); return; }
      var q;
      if (isWhole()) {
        q = query([]);
      } else {
        var picked = pick(sourceValues());
        var maxValues = Math.floor(WEIGHT_BUDGET / Math.max(1, costPerValue(data.param)));
        q = query(picked);
        /* ☠️ Over the 16 KiB wall the storefront answers 414, not "too many";
           over the weight budget it answers 200 with a page nobody on a phone
           should be sent. Either way a band too broad to spell out falls back to
           the sizes this page rendered. That is exactly today's coverage:
           narrower than we'd like, never wrong, and it only happens on bands so
           wide they return most of the catalogue anyway. */
        if (q.length > URL_BUDGET || picked.length > maxValues) {
          q = query(pick(values));
        }
        /* ☠️ Still over: submit nothing rather than a 414. An unknown or
           malformed filter fails OPEN on Shopify — it returns the whole
           catalogue — so a silent overflow would look exactly like "the filter
           did nothing". Better to leave the sizes alone and keep the page. */
        if (q.length > URL_BUDGET) { paint(); return; }
      }
      window.location.search = q ? '?' + q : '';
    }

    paint();
    return el;
  }

  ready(function () {
    var groups = document.querySelectorAll('[data-filter-group]');
    Array.prototype.forEach.call(groups, function (group) {
      if (group.getAttribute('data-rb-type') === 'price_range') { return; }
      var data = readGroup(group);
      if (!data) { return; }
      var list = group.querySelector('.collection-filters__filter-list');
      if (!list) { return; }
      var control = build(group, data);
      var item = document.createElement('li');
      item.className = 'rbdr-item';
      item.appendChild(control);
      list.classList.add('rbdr-hid');
      list.insertBefore(item, list.firstChild);
    });
  });
}());
